import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';

@Component({
  selector: 'app-head',
  standalone: true,
  imports: [
    CommonNgModule
  ],
  templateUrl: './head.component.html',
  styleUrls: ['./head.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeadComponent implements OnInit {
  @Input() Theme:any;
  constructor() { }

  ngOnInit() {
  }

}
